<div
  *ngIf="toast"
  class="app-toast"
  [class.success]="toast.type === 'success'"
  [class.error]="toast.type === 'error'"
  [class.warning]="toast.type === 'warning'"
>
  <svg
    *ngIf="toast.type === 'success'"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="3"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
  {{ toast.message }}
</div>
